var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"media-detail-container"},[_c('div',{staticClass:"media-detail-content"},[_c('img',{attrs:{"src":_vm.src}})]),_c('div',{staticClass:"media-detail-info"})])
}
var staticRenderFns = []

export { render, staticRenderFns }